<div class="posted-order-line-items--wrapper relative">
  <table class="lum-table lum-table--classic striped">
    <thead>
      <tr class="table__head-row">
        <th>Order Key</th>
        <th>Remote Reference Identifier</th>
        <th>Warehouse Group</th>
        <th>Destination OMS</th>
        <th>Destination OMS Store</th>
        <th>Status</th>
        <th width="30px">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <ng-container
        *ngFor="
          let salesOrderShipment of salesOrderShipments;
          trackBy: trackByValue
        "
      >
        <tr
          [ngClass]="{
            'text-danger':
              salesOrderShipment.orderStatus !== statusConstant.PENDING,
          }"
        >
          <td>{{ salesOrderShipment?.orderKey }}</td>
          <td>{{ salesOrderShipment?.sourceReferenceIdentifier }}</td>
          <td>{{ salesOrderShipment?.warehouseGroup?.label }}</td>
          <td>{{ salesOrderShipment?.destinationOms?.label }}</td>
          <td>{{ salesOrderShipment?.destinationOmsStore?.storeName }}</td>
          <td>{{ salesOrderShipment?.orderStatus }}</td>
          <td class="table__actions">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <i class="flaticon-more"></i>
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                (click)="printShippingLabel(salesOrderShipment.id)"
              >
                Print Shipping Label
              </button>
              <button
                mat-menu-item
                (click)="viewFulfillmentOrder(salesOrderShipment.id)"
              >
                View Fulfillment Order
              </button>
              <!-- <button
                mat-menu-item
                (click)="updateFulfillmentOrder(salesOrderShipment.id)"
              >
                Update Fulfillment Order
              </button> -->
              <button
                mat-menu-item
                (click)="updateStatusFulfillmentOrder(salesOrderShipment.id)"
              >
                Update Status Fulfillment Order
              </button>
              <button
                mat-menu-item
                (click)="deleteFulfillmentOrder(salesOrderShipment.id)"
              >
                Delete Fulfillment Order
              </button>
            </mat-menu>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
